import application from "stimulus_application";
import SlidesBoardController from "./slides_board_controller";
import "./slides_board.css";

application.register("slides-board", SlidesBoardController);
